import axios from 'axios';
import { env } from '@/consts';
import { useAuthStore } from '@/stores';

// import { refreshToken } from './token';

// Create an Axios instance
const apiBearer = axios.create({
  baseURL: env.api_url,
  timeout: 10000,
});

// let isRefreshing = false;
interface QueuePromise {
  resolve: (token: string) => void;
  reject: (error: unknown) => void;
}

let failedQueue: QueuePromise[] = [];

export const processQueue = (error: unknown, token: string | null) => {
  failedQueue.forEach(({ resolve, reject }) => {
    if (token) {
      resolve(token);
    } else {
      reject(error);
    }
  });
  failedQueue = [];
};

// Request Interceptor: Attaching Bearer Token
apiBearer.interceptors.request.use(
  (config) => {
    const { access_token } = useAuthStore.getState();
    config.headers['Authorization'] = `Bearer ${access_token}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor: Handling Errors
apiBearer.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { logout } = useAuthStore.getState();
    if (error.response) {
      if (error.response?.status === 401) {
        logout();
      }
    }

    // const { refresh_token, updateToken, logout } = useAuthStore.getState();
    // const originalRequest = error.config;

    // if (error.response) {
    //   console.error('API Error:', error.response.status, error.response.data);
    //   if (error.response?.status === 401 && !originalRequest._retry) {
    //     if (isRefreshing) {
    //       return new Promise((resolve, reject) => {
    //         failedQueue.push({ resolve, reject });
    //       }).then((token) => {
    //         originalRequest.headers['Authorization'] = `Bearer ${token}`;
    //         return apiBearer(originalRequest);
    //       });
    //     }
    //     originalRequest._retry = true;
    //     isRefreshing = true;
    //     try {
    //       const { data } = await refreshToken({
    //         client_id: env.client_id,
    //         client_secret: env.client_secret,
    //         refresh_token,
    //         grant_type: 'refresh_token',
    //       });

    //       updateToken(data);
    //       processQueue(null, data.access_token);

    //       originalRequest.headers['Authorization'] = `Bearer ${data.access_token}`;
    //       return apiBearer(originalRequest);
    //     } catch (err) {
    //       processQueue(err, null);
    //       logout();
    //       return Promise.reject(err);
    //     } finally {
    //       isRefreshing = false;
    //     }
    //   }
    // }
    return Promise.reject(error);
  }
);

export default apiBearer;
